import { render, staticRenderFns } from "./InventoryProcessedL2PChart.vue?vue&type=template&id=4307484c&scoped=true&"
import script from "./InventoryProcessedL2PChart.vue?vue&type=script&lang=js&"
export * from "./InventoryProcessedL2PChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4307484c",
  null
  
)

export default component.exports